import React from 'react';

interface StatusBannerProps {
    alertLevel: string;
    monthsRemaining: number;
    projectedExhaustionDate: string | null;
}

const CONFIG: Record<string, { bg: string; border: string; text: string }> = {
    OK: {
        bg: 'bg-semantic-bg-success-secondary',
        border: 'border-semantic-border-success',
        text: 'text-semantic-text-success',
    },
    WARNING: {
        bg: 'bg-semantic-bg-warning-secondary',
        border: 'border-semantic-border-warning',
        text: 'text-semantic-text-warning',
    },
    CRITICAL: {
        bg: 'bg-semantic-bg-danger-secondary',
        border: 'border-semantic-border-danger',
        text: 'text-semantic-text-danger',
    },
};

const StatusBanner: React.FC<StatusBannerProps> = ({
    alertLevel,
    monthsRemaining,
    projectedExhaustionDate,
}) => {
    const cfg = CONFIG[alertLevel] || CONFIG.OK;
    const iconSymbol = alertLevel === 'OK' ? '\u2713' : '!';

    const detail =
        alertLevel === 'OK'
            ? 'Points consumption is within normal parameters.'
            : `Points will be exhausted in approximately ${monthsRemaining} months${projectedExhaustionDate ? ` (${projectedExhaustionDate})` : ''}. Attention required.`;

    return (
        <div
            className={`flex items-center gap-4 rounded-sm border-l-4 ${cfg.bg} ${cfg.border} p-4 mb-4`}
        >
            <div
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${cfg.bg} ${cfg.text} text-lg font-bold`}
            >
                {iconSymbol}
            </div>
            <div>
                <div className={`text-sm font-semibold ${cfg.text}`}>
                    {alertLevel}
                </div>
                <div className={`text-xs ${cfg.text} opacity-80`}>{detail}</div>
            </div>
        </div>
    );
};

export default StatusBanner;
